import { build } from "../../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/profile/carriers/oauth/uber",
		component: lazy(() => import("./UberOAuthPage")),
	}
]);
